import React from "react";
import styles from "../../assets/jss/material-kit-react/components/headerStyle.js";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);

export default function MobileMenuLinks({ scrollToElement, english }) {
  const classes = useStyles();
  return (
    <div className={classes.mobileLinksContainer}>
      <a
        href="#hvilke-selskaper-er-involvert"
        className={classes.mobileMenuLinks}
        onClick={() =>
          scrollToElement(
            document.getElementById("hvilke-selskaper-er-involvert")
          )
        }
      >
        {english
          ? "Which companies are involved?"
          : "Hvilke selskaper er involverte?"}
      </a>
      <a
        href="#om-okkupasjonen"
        className={classes.mobileMenuLinks}
        onClick={() =>
          scrollToElement(document.getElementById("om_okkupasjonen"))
        }
      >
        {english ? "About the occupation" : "Om okkupasjonen"}
      </a>
      <a
        href="#om_kampanjen"
        className={classes.mobileMenuLinks}
        onClick={() => scrollToElement(document.getElementById("om_kampanjen"))}
      >
        {english ? "About the campagin" : "Om kampanjen"}
      </a>
      <a
        href="#om_oljefondet"
        className={classes.mobileMenuLinks}
        onClick={() =>
          scrollToElement(document.getElementById("om_oljefondet"))
        }
      >
        {english ? "About the oil fund" : "Om oljefondet"}
      </a>
      <a
        href="#hva_sier_partiene"
        className={classes.mobileMenuLinks}
        onClick={() =>
          scrollToElement(document.getElementById("hva_sier_partiene"))
        }
      >
        {english ? "What do Norway's political parties say?" : "Hva sier partiene"}
      </a>
    </div>
  );
}
